import symbol from '/static/images/symbolLogin.svg';

import {
  StyledRegisterSymbolContainer,
  StyledRegisterSymbol,
} from 'pages/Register/Register.style';

import RegisterForm from 'pages/Register/RegisterForm';
import { RESEND_VERIFICATION_CODE_COOLDOWN_MS } from 'constants/memberCenter';
import { PATH } from 'routes/routeConfig';
import { useNavigate } from 'react-router-dom';
import { IRegisterInfo } from 'types/register';

const Register = () => {
  const navigate = useNavigate();

  const handleSubmit = ({ username, email }: IRegisterInfo) => {
    const resendAvailableAt = Date.now() + RESEND_VERIFICATION_CODE_COOLDOWN_MS;
    const params = new URLSearchParams({
      account: username,
      email,
      resendAvailableAt: String(resendAvailableAt),
      source: 'register',
    });
    navigate(`${PATH.VERIFY_EMAIL}?${params.toString()}`);
  };

  return (
    <>
      <RegisterForm onSubmit={handleSubmit} />
      <StyledRegisterSymbolContainer>
        <StyledRegisterSymbol src={symbol} />
      </StyledRegisterSymbolContainer>
    </>
  );
};

export default Register;
